/* Marla's Oct 24 2026: product tiles.
   - Desktop: hovering a colour dot shows that colour's photo (no click needed). Clicking still works.
   - Phones: swipe the photo to see the back photo (dots underneath); tapping a colour dot shows that colour
     and jumps back to the front photo. */
(function () {
  if (window.__mcSwipe) return; window.__mcSwipe = true;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  // Desktop hover preview
  if (canHover) {
    var timer;
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('product-card .color-swatch[for]');
      if (!sw) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var input = document.getElementById(sw.getAttribute('for'));
        if (input && !input.checked && !input.disabled) input.click();
      }, 60);
    });
  }

  // Phone swipe
  function setup(root) {
    if (canHover) return;
    (root || document).querySelectorAll('.product-card__media:not(.mc-swipe)').forEach(function (m) {
      if (!m.querySelector('.product-card__image--secondary')) return;
      m.classList.add('mc-swipe');
      var fig = m.closest('.product-card__figure') || m.parentElement;
      var dots = document.createElement('div');
      dots.className = 'mc-dots';
      dots.innerHTML = '<i class="on"></i><i></i>';
      fig.appendChild(dots);
      m.addEventListener('scroll', function () {
        var second = m.scrollLeft > m.clientWidth / 2;
        dots.children[0].classList.toggle('on', !second);
        dots.children[1].classList.toggle('on', second);
      }, { passive: true });
    });
  }
  // Tapping a colour dot: go back to the front photo of the new colour
  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('product-card');
    if (!card) return;
    var m = card.querySelector('.product-card__media.mc-swipe');
    if (m) m.scrollTo({ left: 0, behavior: 'smooth' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); }); else setup();
  // Tiles added later (filters, next page)
  new MutationObserver(function () { setup(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
